import React, { useState } from "react";

//UI Material
import {
  Avatar,
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

//Helpers
import { selectProductImage } from "../../Helpers/productSelector";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Material Icons
import { Delete, Edit } from "@mui/icons-material";

//Local components
import SetProductDrawer from "../drawers/SetProductDrawer";
import ModalWindow from "../Modal";

export default function ProductInfo({ data, getProduct }) {
  // ==========>Component States<==========
  //State for open/close drawer for set product
  const [openDrawer, setOpenDrawer] = useState(false);
  //State for loading in delete request
  const [isLoading, setIsLoading] = useState(false);
  //State for error in delete request
  const [isError, setIsError] = useState(false);
  //Open modal for delete confirmation/response
  const [openModal, setOpenModal] = useState(false);

  // ==========> Component Functions<==========
  //Function for delete product from DB
  const deleteProduct = async () => {
    setOpenModal(false);
    setIsLoading(true);
    try {
      const res = await fetchWithTokenJSONPost("/products/delete-product", {
        productId: data.productId,
      });
      const jsonResponse = await res.json();

      if (jsonResponse.status === "ok") {
        window.location.href = "/products";
      }
    } catch (error) {
      setIsError(true);
    }
    setIsLoading(false);
  };

  // ==========> Component <==========
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <SetProductDrawer
          open={openDrawer}
          setOpen={setOpenDrawer}
          existingProductData={data}
          getData={getProduct}
          isNewProduct={false}
        />
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información del producto
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            textAlign="left"
          >
            <Avatar
              src={selectProductImage(data.productName)}
              alt="product-img"
              sx={{ height: "100px", width: "100px" }}
            />
            <Typography variant="h5" fontWeight="bold">
              {data.productName}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Detalles del producto
            </Typography>
            <Typography variant="body2">{data.details}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Precio en dólares (USD)
            </Typography>
            <Typography variant="body2">{`$${data.priceInUSD}`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Precio en colones (CRC)
            </Typography>
            <Typography variant="body2">{`₡${data.priceInCRC}`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="right">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
          >
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ color: "white" }}
              endIcon={<Edit />}
              onClick={() => {
                setOpenDrawer(true);
              }}
            >
              EDITAR PRODUCTO
            </Button>
            {isLoading ? (
              <CircularProgress size={25} />
            ) : (
              <Button
                variant="contained"
                size="small"
                color="error"
                sx={{ color: "white" }}
                endIcon={<Delete />}
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Remover producto
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
        leftText="Cancelar"
        leftClick={() => {
          setOpenModal(false);
        }}
        rightText="Sí, Remover"
        rightColor="error"
        rightClick={deleteProduct}
        title="Remover producto"
        text="¿Desea remover este producto permanentemente del sistema?"
      />
      <ModalWindow
        isOpen={isError}
        handleClose={() => {
          setIsError(false);
        }}
        leftText="Ok"
        leftClick={() => {
          setIsError(false);
        }}
        title="No se pudo realizar la acción"
        text="No se pudo remover el producto, por favor intente nuevamente."
      />
    </Card>
  );
}
